export const tealiumSearchTrackingData = {
	tealium_event: 'nav_interaction',
	interaction_source: 'page',
	nav_type: 'Search',
};
